<template>
  <div id='' style='' class='gPageBorder'>
    <el-form class='gForm' label-position="right" ref="form" :rules='rules' label-width="12.5%" :model='form'>
      <el-form-item :label="$t('app_secrname')" prop='name'>
        <el-input v-model="form.name" placeholder=""></el-input>
      </el-form-item>
      <el-form-item :label="$t('app_secrdesc')" prop='desc'>
        <el-input v-model="form.desc" placeholder=''></el-input>
      </el-form-item>
     
      <el-form-item>
        <el-button  type='' style='' @click="cancel">{{$t('app_cancel')}}</el-button>
        <el-button  type='primary' style='' @click="save('form')">{{$t('app_save')}}</el-button>
      </el-form-item>
    </el-form>
   
  </div>
</template>

<style>
</style>

<script>
  export default{
    data () {
      var phoneCheck = (rule, value, callback) => {
        if (!this.isLegalMobile(value)) {
          callback(new Error(this.$t('app_phoneIllegal')));
        } else {
          callback()
        }
      }
      return {
        fatherList: [],
        form: {
          name: '',
          desc: '',
        },
        rules: {
          name: [
            { required: true, message: this.$t('app_input'), trigger: 'blur' }
          ],
          desc: [
            { required: true, message: this.$t('app_input'), trigger: 'blur' }
          ],
        }
      }
    },
    methods: {
      isLegalMobile (tel) {
        var sMobile = tel
        var regex = "^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\\d{8}$"
        var re = new RegExp(regex, 'g') 
        if(!(re.test(sMobile))){
          return false
        } else {
          return true
        }
      },
      newform () {
        this.loading = 1
        this.$addKey(this.form.name, this.form.desc, '', (res) => {
          this.loading = 0
          if (res.status === 200) {
            this.$router.go(-1)
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.loading = 0
        })
      },
      editform () {
        var data = this.config.data
        // console.log(this.form)
        this.loading = 1
        this.$editKey(data.id, this.form.name, this.form.desc, '', (res) => {
          this.loading = 0
          if (res.status === 200) {
            if (this.config.isSetLc) {
              this.config.data.keyName = this.form.name
              this.config.data.memo = this.form.desc
              this.$setWObj('keyruleDetail', this.config.data)
            }
            this.$router.go(-1)
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          this.loading = 0
        }) 
      },
      save (name) {
        // console.log(this.form)
        this.$refs[name].validate((valid) => {
          if (valid) {
            if (this.config.type === 0) {
              this.newform()
            } else {
              this.editform()
            }
          } else {
            return false
          }
        })
      },
      cancel () {
        this.$router.go(-1)
      },
      fillData (data) {
        console.log(data)
        this.form.name = data.keyName
        this.form.desc = data.memo
      }
    },
    mounted () {
      this.config = this.$getWObj().keyEdit
      if (this.config.type === 1) {
        this.fillData(this.config.data)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// edit.vue?7ba61520